var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { attrs: { id: "default-page" } }, [
    _c("div", { staticClass: "container full-width" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "search-result-top" }, [
          _c("div", { staticClass: "top" }, [
            _c("div", { staticClass: "left" }, [
              _vm.vehicle_id
                ? _c("h2", [
                    _vm._v("Activity for vehicle " + _vm._s(_vm.vehicle_id))
                  ])
                : _c("h2", [
                    _vm._v("Last " + _vm._s(_vm.days) + " days of activity")
                  ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "bottom" },
            [
              _c("b-form-select", {
                staticClass: "form-control",
                attrs: { options: _vm.daysOptions },
                on: { change: _vm.onDayChange },
                model: {
                  value: _vm.days,
                  callback: function($$v) {
                    _vm.days = $$v
                  },
                  expression: "days"
                }
              }),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.per_page,
                      expression: "per_page"
                    }
                  ],
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.per_page = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    }
                  }
                },
                [
                  _c("option", { domProps: { value: 100 } }, [
                    _vm._v("100 per page")
                  ]),
                  _vm._v(" "),
                  _c("option", { domProps: { value: 500 } }, [
                    _vm._v("500 per page")
                  ]),
                  _vm._v(" "),
                  _c("option", { domProps: { value: 1000 } }, [
                    _vm._v("1000 per page")
                  ]),
                  _vm._v(" "),
                  _c("option", { domProps: { value: 10000000 } }, [
                    _vm._v("Show max")
                  ])
                ]
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container-table" },
          [
            _c("b-table", {
              staticClass: "list-table",
              attrs: { items: _vm.result, fields: _vm.fields, responsive: "" },
              scopedSlots: _vm._u([
                {
                  key: "cell(date)",
                  fn: function(data) {
                    return [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.moment.unix(data.item.date).format("MMM D Y")
                          ) +
                          "\n                    "
                      )
                    ]
                  }
                },
                {
                  key: "cell(userName)",
                  fn: function(data) {
                    return [
                      _c(
                        "a",
                        {
                          staticClass: "link",
                          attrs: {
                            href: _vm.$laravelRoute(
                              "users.show",
                              data.item.userId
                            )
                          }
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(data.item.userName)
                          )
                        ]
                      )
                    ]
                  }
                },
                {
                  key: "cell(salesRep)",
                  fn: function(data) {
                    return [
                      _c(
                        "a",
                        {
                          staticClass: "link",
                          attrs: {
                            href: "/users-history/" + data.item.salesRepId
                          }
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(data.item.salesRep)
                          )
                        ]
                      )
                    ]
                  }
                },
                {
                  key: "cell(views)",
                  fn: function(data) {
                    return [
                      data.item.views > 0
                        ? _c(
                            "a",
                            {
                              staticClass: "link",
                              attrs: { href: _vm.viewsLink(data) }
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(data.item.views) +
                                  "\n                        "
                              )
                            ]
                          )
                        : [_vm._v(_vm._s(data.item.views))]
                    ]
                  }
                },
                {
                  key: "cell(bids)",
                  fn: function(data) {
                    return [
                      data.item.bids > 0
                        ? _c(
                            "a",
                            {
                              staticClass: "link",
                              attrs: { href: _vm.bidLink(data) }
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(data.item.bids) +
                                  "\n                        "
                              )
                            ]
                          )
                        : [_vm._v(_vm._s(data.item.bids))]
                    ]
                  }
                }
              ])
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "bottom-table" },
          [
            _vm.total > 0
              ? _c("b-pagination", {
                  attrs: { "total-rows": _vm.total, "per-page": _vm.per_page },
                  model: {
                    value: _vm.current_page,
                    callback: function($$v) {
                      _vm.current_page = $$v
                    },
                    expression: "current_page"
                  }
                })
              : _vm._e()
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d9bbba4e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d9bbba4e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/History/AllHistory.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-d9bbba4e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/History/AllHistory.vue
// module chunks = 0